import ChairishABTest from 'chairisher/abtest';

// TODO: (CHAIR-17819) Delete file after AB test
export default class ProcessingFeeTest extends ChairishABTest {
    static getExperimentName() {
        return 'PROCESSING_FEE_AB_TEST_2';
    }
}
